var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 40,
    viewBox: "0 0 321 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_1837)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_593_1837)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.434 15.636H134.226V17.4C134.226 19.656 132.846 21.984 131.154 22.848L130.578 22.056C132.126 21.3 133.434 19.236 133.434 17.4V15.636ZM133.614 15.636H134.406V17.4C134.406 19.116 135.63 21.048 137.202 21.792L136.638 22.584C134.922 21.732 133.614 19.548 133.614 17.4V15.636ZM130.962 15.192H136.806V16.032H130.962V15.192ZM138.09 14.088H139.098V24.936H138.09V14.088ZM138.858 18.468H140.874V19.308H138.858V18.468ZM145.033 20.448H146.017V23.112H145.033V20.448ZM148.501 20.424H149.473V23.1H148.501V20.424ZM142.297 22.776H152.125V23.604H142.297V22.776ZM143.485 14.892H150.913V18.168H144.505V20.352H143.521V17.376H149.929V15.696H143.485V14.892ZM143.521 19.908H151.165V20.724H143.521V19.908ZM157.769 15.06H162.749V20.088H157.769V15.06ZM161.777 15.864H158.741V19.284H161.777V15.864ZM164.741 14.076H165.737V22.032H164.741V14.076ZM165.425 17.388H167.345V18.216H165.425V17.388ZM158.981 23.88H166.229V24.696H158.981V23.88ZM158.981 21.276H159.977V24.228H158.981V21.276ZM168.864 18.612H178.668V19.428H168.864V18.612ZM170.16 16.932H177.504V17.736H170.16V16.932ZM170.16 14.436H177.384V15.252H171.144V17.58H170.16V14.436ZM170.04 20.364H177.408V22.92H171.048V24.288H170.064V22.176H176.424V21.144H170.04V20.364ZM170.064 24.024H177.732V24.816H170.064V24.024ZM188.299 14.088H189.295V24.936H188.299V14.088ZM185.119 15.252H186.103C186.103 18.396 184.687 21.144 181.063 22.92L180.535 22.116C183.667 20.604 185.119 18.3 185.119 15.42V15.252ZM181.027 15.252H185.551V16.068H181.027V15.252Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_593_1837",
    x1: 0,
    y1: 20,
    x2: 321,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5134DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5C10B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5134DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_1837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 321,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeMaterial);
export default __webpack_public_path__ + "static/media/makeMaterial.688235b05838834a0f222b57d22fb7c7.svg";
export { ForwardRef as ReactComponent };